import React from 'react';
import Clickwrap from 'components/Clickwrap';

const EventCheckbox = ({ isChecked, setEventAllDay }) => {
  return (
    <div className="event-card__checkbox">
      <Clickwrap
        name="all_day"
        checked={isChecked}
        className="clickwrap--view-option small"
        onChange={() => setEventAllDay(!isChecked)}
      />
      <label htmlFor="all_day">All Day</label>
    </div>
  );
};

export default EventCheckbox;
